import getBlockSendersConfirmTitleAndSubtext from './getBlockSendersConfirmTitleAndSubtext';
import blockSenderService from '../../services/blockSenderService';
import { confirm, DialogResponse } from 'owa-confirm-dialog';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import { Checkbox } from 'office-ui-fabric-react/lib/Checkbox';
import * as React from 'react';
import addDomainsToBlockedList from '../actionCreators/addDomainsToBlockedList';

let blockDomain = false;

/**
 * Shows the confirm dialog before sending out the block service call
 * @param mailboxes to block
 * @param blockActionCallback to be called upon sending out the service call
 */
export default async function blockLastSendersHelper(
    mailboxes: EmailAddressWrapper[],
    blockActionCallback: () => void
) {
    if (!mailboxes) {
        // Do nothing in case of invalid mailboxes,
        // i.e mailboxes is null when user tries to block self
        return;
    }
    // Start block domain checkbox as unchekced
    blockDomain = false;

    const domains = getUniqueDomains(mailboxes);
    const [title, subtext, domainSubtext] = getBlockSendersConfirmTitleAndSubtext(
        mailboxes,
        domains
    );
    const checkBox = React.createElement(Checkbox, {
        key: 'blockDomainCheckbox',
        defaultChecked: blockDomain,
        label: domainSubtext,
        onChange: toggleBlockDomain,
    });
    const confirmResponse = await confirm(title, subtext, false /* resolveImmediately */, {
        bodyElement: checkBox,
    });

    if (confirmResponse !== DialogResponse.ok) {
        return;
    }

    if (blockDomain) {
        addDomainsToBlockedList(domains);
    }

    try {
        blockSenderService(mailboxes);
    } catch (error) {
        // VSO 19006: Handle service error caused by block
    }

    blockActionCallback();
}

function toggleBlockDomain() {
    blockDomain = !blockDomain;
}

function getUniqueDomains(mailboxes: EmailAddressWrapper[]): string[] {
    // Get all domains
    const domains = mailboxes.map((emailAddress: EmailAddressWrapper) => {
        return emailAddress.EmailAddress.split('@')[1];
    });
    // Remove duplicates
    return domains.filter((a, b) => domains.indexOf(a) === b);
}
